var SectionEnum;
(function (SectionEnum) {
    SectionEnum["header"] = "header";
    SectionEnum["introduction"] = "introduction";
    SectionEnum["overview"] = "overview";
    SectionEnum["analytics"] = "analytics";
    SectionEnum["apply"] = "apply";
    SectionEnum["footer"] = "footer";
})(SectionEnum || (SectionEnum = {}));
export {};
//# sourceMappingURL=mvp.js.map